/* eslint-disable import/prefer-default-export */
export const currentSection = {
  props: ['id', 'headerColor', 'section'],
  data() {
    return {
      color: this.headerColor || 'black',
      scrollPosition: null
    };
  },
  mounted() {
    window.addEventListener('scroll', this.updateScroll);
  },
  methods: {
    updateScroll() {
      this.scrollPosition = window.scrollY;
      let sectionTop = 0;
      const element = this.$refs.hero;
      if (element) {
        sectionTop = element.getBoundingClientRect().top;
      }
      if (sectionTop <= 80) {
        this.$emit('sectionChanged', { id: this.id, headerColor: this.headerColor });
      }
    }
  }
};
